<template>
  <div
    class="modal has-overflow"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">

      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ title }}
          </p>
          <button
            class="delete"
            aria-label="close"
            @click="close()">
          </button>
        </header>

        <v-form class="modal-card-body" :valid.sync="valid">

          <div class="field">
            <label class="label">RFQ Name / Version*</label>
            <v-text-field
              required
              placeholder="RFQ Name"
              v-model="duplicate.rfq_name"/>
            <span v-if="duplicateEstimation">

            </span>
          </div>

          <div class="field" v-if="!duplicateEstimation">
            <label class="label">Items to Duplicate*</label>
            <v-checkbox 
              v-model="duplicate.drawing_highlights"
              label="drawing highlights"/>
            <v-checkbox 
              v-model="duplicate.c_estimation"
              label="estimation"/>
          </div>

        </v-form>
        
        <footer class="modal-card-foot">
          <button 
            v-if="!duplicateEstimation"
            :disabled="!valid || saving"
            :class="{ 'is-loading': saving }"
            class="button is-primary" 
            @click.stop="save()">
            Save
          </button>

          <template v-if="duplicateEstimation">
            <button 
              :disabled="!valid || saving"
              :class="{ 'is-loading': saving }"
              class="button is-primary" 
              @click.stop="save(true)">
              Save & Edit New Estimation
            </button>
            <button 
              :disabled="!valid || saving"
              :class="{ 'is-loading': saving }"
              class="button" 
              @click.stop="save()">
              Save & Stay on Same Estimation
            </button>
          </template>

          <button 
            class="button" 
            @click.stop="close(true)">
            Cancel
          </button>
        </footer>

      </div>
    </div>
  </div>
</template>

<script>
import VForm from '@/components/base/VForm'
import VCheckbox from '@/components/base/VCheckbox'
import VTextField from '@/components/base/VTextField'

import { mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    },
    rfq: {
      type: Object
    },
    duplicateEstimation: {
      type: Boolean,
      default: false
    },
  },
  components: { 
    VForm, VTextField, VCheckbox
  },
  data() {
    return {
      valid: false,
      saving: false,
      duplicate: {
        rfq_name: null,
        documents: true,
        drawing_highlights: true,
        c_estimation: true,
        reset_rfq: true,
        reset_drawing_highlights: true,
        reset_estimation: true
      }
    }
  },
  computed: {
    title() {
      return this.duplicateEstimation ? 'Create New Version of Estimation' : 'Duplicate an RFQ';
    }
  },
  watch: {
    value(v) {
      if (this.rfq) {
        this.duplicate.rfq_name = this.rfq.rfq_name;
      }
    }
  },
  methods: {
    ...mapActions("rfqsProjects", ["duplicateRfq"]),
    save(goToNewEstimation=false) {
      this.saving = true;

      if (this.duplicateEstimation) {
        this.duplicate.reset_rfq = false;
        this.duplicate.reset_drawing_highlights = false;
      }

      this.duplicateRfq({
        rfqId: this.rfq.id,
        data: this.duplicate
      }).then(resp => {
        if (goToNewEstimation) {
          let routeName = resp.data.product_brand == 'Mitrex' ? 
            'EstimationViewerMitrex' : 'EstimationViewerCladify';
          this.$router.push({ 
            name: routeName, 
            params: { estimationId: resp.data.c_estimation.id } 
          });
        }
        this.saving = false;
        this.close(true);
      }).catch(() => this.saving = false);
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>